import {useState} from 'react';
import clsx from 'clsx';
import InputText from '@di-shared/features/common/InputText';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {formatNumberWithCommas} from '@di-shared/utils';
import useCldrDatetimeFormatter from '@di-shared/utils/useCldrDatetimeFormatter';
import {parseDateWithFormat} from '@shared/dateUtils';

interface UpdateOdometerBottomSheetData {
  isOdometerDataExist: boolean;
  odometer: number;
  updatedAt: string;
}

export default function UpdateOdometerBottomSheet() {
  const {t} = useInferableTranslation();
  const {isOdometerDataExist, odometer, updatedAt} = (window as any).data as UpdateOdometerBottomSheetData;
  const [inputOdometer, setInputOdometer] = useState<string>('');
  const CldrDatetimeFormatter = useCldrDatetimeFormatter();

  const isInputValid = inputOdometer === '' || (!isNaN(Number(inputOdometer)) && Number(inputOdometer) > 0);
  const parsedUpdatedAt = parseDateWithFormat(updatedAt);
  return (
    <div
      className="bottom_sheet bottom_sheet_driving_distance" //
    >
      <div className="bottom_sheet_header">
        <h2 className="bottom_sheet_title">{t('T10153')}</h2>
        <button
          aria-label={t('T10017')}
          className="btn btn_ic"
          type="button"
          onClick={() => window.bottomSheetClose()}
        >
          <span
            className="ic ic_close_20px"
            aria-hidden="true"
          />
        </button>
      </div>
      <div className="bottom_sheet_inner">
        <div className="bottom_sheet_contents">
          <label
            className="blind"
            htmlFor="enterDistance"
          >
            {t('T30155')}
          </label>
          <div className={clsx('input_box input_box_field', {input_error: !isInputValid})}>
            <InputText
              id="enterDistance"
              type="text"
              inputMode="numeric"
              className="input_text body_large_r"
              regex={/[^0-9]/g}
              autofucus
              initValue={inputOdometer ? formatNumberWithCommas(inputOdometer) : ''}
              placeholder={isOdometerDataExist ? formatNumberWithCommas(odometer) : ''}
              onChange={(value) => setInputOdometer(value)}
            />
            {inputOdometer !== '' && (
              <div className="box_right">
                <button
                  className="btn_delete_input"
                  type="button"
                  onMouseDown={(e) => {
                    e.preventDefault();
                    setInputOdometer('');
                  }}
                >
                  <span className="ic ic_filled_delete_20px">{t('T10154')}</span>
                </button>
              </div>
            )}
          </div>
          {!isInputValid && <p className="txt_error body_small_r">{t('T30607')}</p>}

          {isOdometerDataExist && isInputValid && parsedUpdatedAt && (
            <p className="input_desc">
              {t('T10156')}
              <span className="divider divider_vertical" />
              {CldrDatetimeFormatter.format(parsedUpdatedAt, 'yMMMd')}
            </p>
          )}
        </div>

        <div className="bottom_sheet_footer">
          <button
            className={clsx('btn btn_large btn_filled')}
            disabled={!isInputValid || inputOdometer === ''}
            type="button"
            onClick={() => (window as any).bottomSheetClose(inputOdometer)}
          >
            {t('T30049')}
          </button>
        </div>
      </div>
    </div>
  );
}
